export const API_URL = process.env.REACT_APP_API_URL;
export const RAZORPAY_KEY = process.env.RAZORPAY_KEY;